
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { UserOnboarding } from "./UserOnboarding";
import { RegistrationForm } from "./forms/RegistrationForm";
import { useRegister } from "./hooks/useRegister";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

export const RegisterForm = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    username,
    setUsername,
    loading,
    showOnboarding,
    setShowOnboarding,
    userId,
    error,
    handleRegister,
    onOnboardingComplete
  } = useRegister();
  
  return (
    <>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl text-center">Create an account</CardTitle>
          <CardDescription className="text-center">
            Register to create your own knitting patterns
          </CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <Alert variant="destructive" className="mb-4">
              <AlertTriangle className="h-4 w-4" />
              <AlertTitle>Registration failed</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
        
          <RegistrationForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            username={username}
            setUsername={setUsername}
            loading={loading}
            onSubmit={handleRegister}
          />
        </CardContent>
      </Card>
      
      <UserOnboarding 
        open={showOnboarding}
        onOpenChange={setShowOnboarding}
        onComplete={onOnboardingComplete}
        userId={userId}
        initialDisplayName={username}
      />
    </>
  );
};
